import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { default as version } from "../../../package.json";
import { Auth } from "../../features/Auth";
import logo from "../../shared/assets/img/logo_light.png";
import squares from "../../shared/assets/img/squares.png";
import styles from "./styles.module.css";

export const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className={styles["page-layout"]}>
      <div className={styles["logo-container"]}>
        <img className={styles.logo} src={logo} alt="Логотип Гуреев" />
        <p className={styles.version}>{version.version}-dev</p>
      </div>
      <Auth />
      <img className={styles["background-squares"]} src={squares} alt="" />
    </div>
  );
};
